module.exports = __webpack_public_path__ + "img/linkedin.7ef56d09.png";